var simpleGallery = {

	init: function () {

		$('.m-simple-gallery:not(.js-gallery-done)').each(function () {
			var wrapper = $(this);
			var gallery = wrapper.find('.js-gallery');
			var pager = wrapper.find('.js-pager');
			var imageSlider, pagerSlider, i;
			var data = wrapper.find('script[type="application/json"]:first');


			// load additional images & pager
			if (data.length === 1) {

				data = data.html();

				try {
					data = $.parseJSON(data);
				}
				catch (e) {
					if (console !== 'undefined') {
						console.log('Error: Could not parseJSON for gallery: simple-gallery.js')
					}
				}

				var tmpImage = $('#simpleGalleryImageTemplate').html();
				tmpImage = Hogan.compile(tmpImage);

				var tmpPager = $('#simpleGalleryPagerTemplate').html();
				tmpPager = Hogan.compile(tmpPager);

				// append new items
				for (i = 0; i < data.length; i++) {
					var item = data[i];
					// set index
					item.Index = (i + 1);
					// append
					gallery.append(tmpImage.render(item));
					pager.append(tmpPager.render(item));
				}

				// image slider functionality
				var slides = gallery.find('.js-slide');
				if (slides.length > 1) {
					imageSlider = gallery.bxSlider({
						mode: 'fade',
						pagerCustom: pager.parent().get(0),
						speed: 500,
						infiniteLoop: false,
						hideControlOnEnd: true
					});
				}

				// pager slider functionality
				slides = pager.find('.js-item');
				if (slides.length > 1) {
					pagerSlider = pager.bxSlider({
						pager: false,
						speed: 500,
						minSlides: 2,
						maxSlides: 7,
						moveSlides: 1,
						slideWidth: 125,
						slideMargin: 10,
						infiniteLoop: false,
						hideControlOnEnd: true
					});
				}

				// trigger ajax
				site.doc.trigger('ajaxComplete');
			}

			// done
			wrapper.addClass('js-gallery-done');
		});

	}

};

$(function () {
	simpleGallery.init();
	site.doc.ajaxComplete(function () {
		simpleGallery.init();
	});
});